import React, { useState, Children } from 'react';
import { ChevronRightIcon, ChevronDownIcon, BuildingIcon } from 'lucide-react';
import { ChartOfAccount } from '../../types/coa.types';
import { Badge } from '../ui/Badge';
interface COATreeViewProps {
  accounts: ChartOfAccount[];
  onAccountClick: (account: ChartOfAccount) => void;
}
interface TreeNodeProps {
  account: ChartOfAccount;
  level: number;
  onAccountClick: (account: ChartOfAccount) => void;
}
function TreeNode({
  account,
  level,
  onAccountClick
}: TreeNodeProps) {
  const [isExpanded, setIsExpanded] = useState(level === 0);
  const hasChildren = account.children && account.children.length > 0;
  return <div data-id="element-124">
      <div className="flex items-center gap-2 py-2 px-3 hover:bg-gray-50 cursor-pointer rounded" style={{
      paddingLeft: `${level * 24 + 12}px`
    }} onClick={() => onAccountClick(account)} data-id="element-125">
        {hasChildren ? <button onClick={e => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
      }} className="text-gray-500 hover:text-gray-700" data-id="element-126">
            {isExpanded ? <ChevronDownIcon className="w-4 h-4" data-id="element-127" /> : <ChevronRightIcon className="w-4 h-4" data-id="element-128" />}
          </button> : <div className="w-4" data-id="element-129" />}

        {account.subType === 'Bank' && <BuildingIcon className="w-4 h-4 text-blue-600" data-id="element-130" />}

        <span className="font-mono text-sm text-gray-600" data-id="element-131">
          {account.accountCode}
        </span>
        <span className="text-sm font-medium text-gray-900" data-id="element-132">
          {account.accountName}
        </span>

        {account.isInactive && <Badge variant="warning" data-id="element-133">Inactive</Badge>}

        {account.balance !== undefined && <span className="ml-auto text-sm font-medium text-gray-900" data-id="element-134">
            ${account.balance.toLocaleString()}
          </span>}
      </div>

      {hasChildren && isExpanded && <div data-id="element-135">
          {account.children!.map(child => <TreeNode key={child.id} account={child} level={level + 1} onAccountClick={onAccountClick} data-id="element-136" />)}
        </div>}
    </div>;
}
export function COATreeView({
  accounts,
  onAccountClick
}: COATreeViewProps) {
  return <div className="bg-white border rounded-lg overflow-hidden" data-id="element-137">
      <div className="bg-gray-50 px-4 py-3 border-b" data-id="element-138">
        <h3 className="text-sm font-semibold text-gray-900" data-id="element-139">
          Account Hierarchy
        </h3>
      </div>
      <div className="p-2" data-id="element-140">
        {accounts.map(account => <TreeNode key={account.id} account={account} level={0} onAccountClick={onAccountClick} data-id="element-141" />)}
      </div>
    </div>;
}